"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavItems = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _head = _interopRequireDefault(require("lodash/fp/head"));

var _includes = _interopRequireDefault(require("lodash/fp/includes"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _size = _interopRequireDefault(require("lodash/fp/size"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _ApplicationActionBar = require("./ApplicationActionBar");

var _modulePropTypes = _interopRequireDefault(require("./modulePropTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var collapsedDropdownWidth = 50;

var NavItems = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NavItems, _Component);

  var _super = _createSuper(NavItems);

  function NavItems(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NavItems);
    _this = _super.call(this, props);
    _this.state = {
      hasComputed: false,
      isCollapsedNavItemOpen: false,
      showCollapsedNavItems: false
    };
    _this.visibleNavItems = [];
    _this.collapsedNavItems = [];
    _this.resetRenderedNavItems = _this.resetRenderedNavItems.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCollapsedDropdown = _this.handleCollapsedDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCollapsedNavItemSelected = _this.handleCollapsedNavItemSelected.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(NavItems, [{
    key: "resetRenderedNavItems",
    value: function resetRenderedNavItems() {
      this.collapsedNavItems = [];
      this.visibleNavItems = [];
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps !== this.props) {
        this.setState(function () {
          return {
            hasComputed: false
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // After the component received new props, every nav item has to be rendered again without
      // collapsing them in the dropdown. Since there is no new render cycle triggered,
      // we need to recalculate the width of the items again and render trhe result.
      if (!this.state.hasComputed) {
        this.computeNavItems();
      }
    }
  }, {
    key: "getAvailableWidth",
    value: function getAvailableWidth(element) {
      // Get relevant elements
      var parent = element.parentNode;
      var actionBar = (0, _head.default)(parent.getElementsByClassName('ApplicationActionBar'));
      var actionBarWidth = actionBar && actionBar.childElementCount > 0 ? actionBar.scrollWidth : 0; // Since the collapsed dropdown has not been rendered yet,
      // use the fixed with for it to compute available width

      var availableWidth = element.scrollWidth - actionBarWidth - collapsedDropdownWidth;
      return availableWidth;
    }
  }, {
    key: "computeNavItems",
    value: function computeNavItems() {
      var _this2 = this;

      if (this.props.isMobile) {
        return;
      }

      var element = this.navigationRef;
      var navItems = (0, _toConsumableArray2.default)(element.children);
      var availableWidth = this.getAvailableWidth(element);
      this.resetRenderedNavItems(); // Iterate over all rendered navItems to figure out their widths in order to figure out
      // which navItems need to be rendered in the collapsed dropdown

      var requiredNavItemsSize = 0;
      navItems.forEach(function (item) {
        if (!item.className) {
          return;
        } // Calculate the remaining width


        requiredNavItemsSize = requiredNavItemsSize + item.scrollWidth; // Use the navItems.key to find corresponding navItems for each DOM node

        var matchedNavItem = _this2.props.navItems.find(function (navItem) {
          var dataAttr = item.attributes['data-nav-item-key'];
          return dataAttr && navItem.key === dataAttr.value;
        }); // Add navItems to the visible group until the available with exceeds.
        // All other navItems will be added to the collapsed group


        if (availableWidth > requiredNavItemsSize) {
          _this2.visibleNavItems.push(matchedNavItem);
        } else {
          _this2.collapsedNavItems.push(matchedNavItem);
        }
      }); // Set the state to render the navItems again

      this.setState(function () {
        return {
          hasComputed: true
        };
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (!event || !event.path) {
        return;
      }

      var isTargetActionBarItem = event.path.find(function (item) {
        return !!item.className && (0, _includes.default)('ActionBarItemIcon', item.className);
      });
      var isPopoverTarget = event.path.find(function (item) {
        return !!item.className && (0, _includes.default)('popover', item.className);
      }); // Do not close when any ActionBarItemIcon was clicked but close when a popover is is clicked

      if (!isTargetActionBarItem && this.state.isCollapsedNavItemOpen || isPopoverTarget) {
        this.setState(function () {
          return {
            isCollapsedNavItemOpen: false
          };
        });
      }
    }
  }, {
    key: "handleCollapsedDropdown",
    value: function handleCollapsedDropdown() {
      // When the dropdown is open, set showCollapsedNavItems to false so all sumodule items
      // are rendered and their size can be computed
      if (this.state.isCollapsedNavItemOpen) {
        this.setState(function () {
          return {
            isCollapsedNavItemOpen: false
          };
        });
      } else {
        // When the dropdown is closed, just set the flag to open is enough
        this.setState(function () {
          return {
            isCollapsedNavItemOpen: true
          };
        });
      }
    }
  }, {
    key: "handleCollapsedNavItemSelected",
    value: function handleCollapsedNavItemSelected() {
      // Close collapsed dropdown on item select
      if (this.state.isCollapsedNavItemOpen) {
        this.setState(function () {
          return {
            isCollapsedNavItemOpen: false
          };
        });
      }
    }
  }, {
    key: "renderCollapsedNavItem",
    value: function renderCollapsedNavItem(collapsedNavItems) {
      var _this3 = this;

      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          containerWidth = _this$props.containerWidth,
          actionBarItems = _this$props.actionBarItems;
      var collapsedDropdownClass = this.state.isCollapsedNavItemOpen ? 'open' : '';
      var inlineStyle = isMobile ? {
        width: "".concat(containerWidth, "px")
      } : {};

      if (!collapsedNavItems.length && !actionBarItems.length) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("li", {
        className: "CollapsedDropdown dropdown ".concat(collapsedDropdownClass),
        key: 'collapsed-dropdown'
      }, /*#__PURE__*/_react.default.createElement("a", {
        id: "basic-nav-dropdown",
        role: "button",
        className: "dropdown-toggle",
        "aria-haspopup": "true",
        "aria-expanded": "true",
        onClick: this.handleCollapsedDropdown
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rioglyph rioglyph-option-horizontal",
        "aria-hidden": "true"
      })), /*#__PURE__*/_react.default.createElement("ul", {
        className: 'dropdown-menu',
        role: "menu",
        "aria-labelledby": "basic-nav-dropdown",
        style: inlineStyle
      }, /*#__PURE__*/_react.default.createElement(_ApplicationActionBar.ApplicationActionBar, {
        items: this.props.actionBarItems
      }), collapsedNavItems.map(function (navItem) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: navItem.key,
          className: 'submodule nav-link-item',
          onClick: _this3.handleCollapsedNavItemSelected,
          "data-nav-item-key": navItem.key
        }, navItem.route);
      })));
    }
  }, {
    key: "renderNavItem",
    value: function renderNavItem(navItem, isOffscreen) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: navItem.key,
        className: "submodule nav-link-item ".concat(isOffscreen ? 'offscreen' : ''),
        "data-nav-item-key": navItem.key
      }, navItem.route);
    }
  }, {
    key: "renderNavItems",
    value: function renderNavItems() {
      var _this4 = this;

      var _this$props2 = this.props,
          isMobile = _this$props2.isMobile,
          navItems = _this$props2.navItems,
          actionBarItems = _this$props2.actionBarItems;
      var isOffscreen = !this.state.hasComputed;
      var hasNavItems = !(0, _isEmpty.default)(navItems);
      var hasSingleActionItem = (0, _size.default)(actionBarItems) === 1;

      if (isMobile) {
        return !hasNavItems && hasSingleActionItem ? /*#__PURE__*/_react.default.createElement(_ApplicationActionBar.ApplicationActionBar, {
          items: actionBarItems,
          className: 'position-relative'
        }) : this.renderCollapsedNavItem(navItems);
      }

      if (!isOffscreen && this.collapsedNavItems.length) {
        var items = this.visibleNavItems.map(function (navItem) {
          return _this4.renderNavItem(navItem, isOffscreen);
        });
        items.push(this.renderCollapsedNavItem(this.collapsedNavItems));
        return items;
      }

      return navItems.map(function (navItem) {
        return _this4.renderNavItem(navItem, isOffscreen);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      // As all navItems need to be added to the DOM first in order to get their real size
      // the computation wheather a navItem need to be shown under the collapsed dropdown or not
      // needs to be done after the component did mount to the DOM.
      var classes = (0, _classnames.default)('SubmoduleNavigation', 'NavItems', 'nav', 'navbar-nav');
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: classes,
        ref: function ref(node) {
          return _this5.navigationRef = node;
        }
      }, this.renderNavItems());
    }
  }]);
  return NavItems;
}(_react.Component);

exports.NavItems = NavItems;

var _default = (0, _reactOnclickoutside.default)(NavItems);

exports.default = _default;
NavItems.defaultProps = {
  navItems: [],
  actionBarItems: []
};
NavItems.propTypes = {
  navItems: _propTypes.default.arrayOf(_modulePropTypes.default),
  containerWidth: _propTypes.default.number.isRequired
};